module.exports = __webpack_public_path__ + "img/larva.2da13e41.svg";